import { isNil, isBoolean, isString, isNumber } from "@mcwd/typescript-type-guards";



export function parseBool (value: unknown, { parseFromNumber = false } = {}): boolean | null
{
  if (isNil(value))
  {
    return null;
  }
  if (isBoolean(value)) return value;
  if (isString(value))
  {
    if (/^true|false$/i.test(value)) return /^true$/i.test(value);
    if (/^0|1$/.test(value))
    {
      value = parseInt(value);
    }
  }
  if (parseFromNumber && isNumber(value) && (value === 0 || value === 1))
  {
    return value === 1;
  }
  return null;
}
